import { __assign } from "tslib";
import React from 'react';
import { View, TouchableHighlight, TouchableOpacity, ActivityIndicator, Image, StyleSheet, Platform } from 'react-native';
// Custom
import c from '../../styles/_colors';
import Text from '../../Typography/PnmacTextMobile';
var icons = {
  arrow: require('../../assets/icon-arrow-right-24.png'),
  check: require('../../assets/icon-check-40.png'),
  fingerprint: require('../../assets/icon-fingerprint.png'),
  angle: require('../../assets/icon-angle-right-20.png')
};
var textColor = function (props) {
  return props.red ? c.red : props.textOnly || props.asRow ? props.textStyle && props.textStyle.fontSize >= 19 ? c.cyan : c.blue : props.loading ? 'rgba(0, 0, 0, 0)' : c.white;
};
var TouchableComponent = function (props) {
  if (props.textOnly) {
    return /*#__PURE__*/React.createElement(TouchableOpacity, __assign({
      activeOpacity: 0.5
    }, props, {
      style: [s.button(props), props.style]
    }), props.children);
  } else if (props.asRow) {
    return /*#__PURE__*/React.createElement(TouchableHighlight, __assign({
      underlayColor: c.buttonActive
    }, props, {
      style: [s.button(props), props.style]
    }), /*#__PURE__*/React.createElement(View, {
      style: s.buttonAsRowInner(props)
    }, props.children));
  } else {
    return /*#__PURE__*/React.createElement(TouchableHighlight, __assign({
      underlayColor: c.cyanActive
    }, props, {
      style: [s.button(props), props.style]
    }), props.children);
  }
};
var PnmacMobileButton = function (props) {
  return /*#__PURE__*/React.createElement(TouchableComponent, __assign({}, props), /*#__PURE__*/React.createElement(View, {
    style: [s.buttonContent(props), props.disabled ? s.buttonDisabled : null]
  }, props.icon == 'check' && /*#__PURE__*/React.createElement(Image, {
    source: icons[props.icon],
    style: {
      marginRight: 10,
      tintColor: textColor(props)
    }
  }), props.icon == 'fingerprint' && /*#__PURE__*/React.createElement(Image, {
    source: icons[props.icon],
    style: {
      marginRight: 10,
      tintColor: textColor(props)
    }
  }), /*#__PURE__*/React.createElement(Text, {
    gilroy: !props.asRow,
    size: props.asRow ? 14 : 19,
    style: [{
      color: textColor(props)
    }, props.textStyle]
  }, props.text), props.icon == 'arrow' && /*#__PURE__*/React.createElement(Image, {
    source: icons[props.icon],
    style: {
      marginLeft: 10,
      tintColor: textColor(props)
    }
  }), props.icon == 'angle' && /*#__PURE__*/React.createElement(Image, {
    source: icons[props.icon],
    style: {
      marginLeft: 10,
      tintColor: textColor(props)
    }
  }), props.loading && /*#__PURE__*/React.createElement(ActivityIndicator, {
    style: {
      position: 'absolute'
    },
    color: c.white,
    animating: props.loading === true
  })));
};
export default PnmacMobileButton;
var s = {
  button: function (props) {
    return __assign({
      backgroundColor: props.textOnly || props.asRow ? 'transparent' : c.cyan,
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: props.asRow ? 0 : props.textOnly ? 5 : 15,
      paddingHorizontal: props.asRow ? 15 : null,
      width: Platform.OS == 'web' && props.asRow ? 'auto' : 'initial',
      borderRadius: !props.asRow ? 48 : props.inCard ? 10 : 0
    }, props.asRow || props.textOnly ? {} : c.shadow(0, 4, 10, c.black, .15));
  },
  buttonDisabled: {
    opacity: .5
  },
  buttonAsRowInner: function (props) {
    return {
      height: 'auto',
      alignSelf: 'stretch',
      paddingVertical: 9,
      paddingHorizontal: 16,
      borderTopWidth: props.asFirstSectionRow ? 0 : StyleSheet.hairlineWidth,
      borderTopColor: c.lighterGray
    };
  },
  buttonContent: function (props) {
    return __assign({
      flexDirection: 'row',
      justifyContent: props.asRow && !props.asRowCentered ? 'space-between' : 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      opacity: 1,
      paddingRight: props.asRow && Platform.OS !== 'web' ? 20 : 0
    }, props.asRow ? {
      alignSelf: 'stretch'
    } : {});
  }
};